import React from 'react';

import { QuestionAssetData } from 'src/application/ContentZone/components/Widgets/_shared/Questions/hooks/useQuestionWidgetAssetProvider';

import { QuestionCheckCorrect } from '../../../../../components/Widgets/_shared/Questions/components/icons/QuestionCheckCorrect';
import { QuestionCheckCorrectNotSelected } from '../../../../../components/Widgets/_shared/Questions/components/icons/QuestionIconCorrectNotSelected';
import { QuestionIconIncorrect } from '../../../../../components/Widgets/_shared/Questions/components/icons/QuestionIconIncorrect';
import { CheckboxIconType } from '../api/questionComponentStudentApi';
import { QuestionRadioButton } from '../atoms/QuestionRadioButton';
import { SmartImage } from '@ael/shared-components-library';
import classNames from 'classnames';

import './QuestionOption.scss';

type CheckboxIconProps = {
  type: CheckboxIconType;
};

const CheckboxIcon: React.FC<CheckboxIconProps> = (props) => {
  switch (props.type) {
    case CheckboxIconType.NotSelected:
      return <QuestionRadioButton selected={false} />;
    case CheckboxIconType.Selected:
      return <QuestionRadioButton selected={true} />;
    case CheckboxIconType.Correct:
      return <QuestionCheckCorrect />;
    case CheckboxIconType.Incorrect:
      return <QuestionIconIncorrect />;
    case CheckboxIconType.CorrectNotSelected:
      return <QuestionCheckCorrectNotSelected />;
  }
};

type QuestionOptionProps = {
  assetData: QuestionAssetData | null;
  text: string;
  isLastOption: boolean;
  iconType: CheckboxIconType;
  disabled: boolean;
  onSelect: () => void;
};

export const QuestionOption: React.FC<QuestionOptionProps> = (props) => {
  return (
    <>
      <div
        className={classNames('question-option-wrapper', {
          'question-option-wrapper--last': props.isLastOption,
        })}
      >
        <div
          className={classNames('question-option', {
            'question-option--selected': props.iconType === CheckboxIconType.Selected,
            'question-option--correct': props.iconType === CheckboxIconType.Correct,
            'question-option--submitted-incorrect': props.iconType === CheckboxIconType.Incorrect,
            'question-option--submitted-correct-not-selected': props.iconType === CheckboxIconType.CorrectNotSelected,
            'question-option--disable-hover': props.disabled,
          })}
          onClick={() => props.onSelect()}
        >
          <CheckboxIcon type={props.iconType} />
          <div className="question-option-description">
            {props.assetData && (
              <div className="question-option-image-wrapper">
                <SmartImage
                  src={props.assetData.url}
                  maxImageHeight="extraSmall"
                  loaderHeight={props.assetData.dimensions?.height}
                  loaderWidth={props.assetData.dimensions?.width}
                  enableZoom
                />
              </div>
            )}
            <div className="question-option-text uno-w-full" dangerouslySetInnerHTML={{ __html: props.text }}></div>
          </div>
        </div>
      </div>
    </>
  );
};
